import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-average-sales-ticket-card',
  templateUrl: './average-sales-ticket-card.component.html',
  styleUrls: ['./average-sales-ticket-card.component.scss'],
})
export class AverageSalesTicketCardComponent implements OnInit {
  public isLoaded: boolean = false;
  public averageTicket: number = 0;
  public averageTicketLastValue: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.getAvailableBalanceAmount();
  }

  getAvailableBalanceAmount() {
    this.isLoaded = true;

    this.dashBoardService
      .getAverageTicket()
      .then((value) => {
        this.averageTicket = value.currentValue;
        this.averageTicketLastValue = value.valueLastPeriod;
      })
      .finally(() => {
        this.isLoaded = false;
      });
  }
}
